export default {
  "auth.login.email": "Email",
  "auth.login.phoneOrEmail": "Phone number or email",
  "auth.login.password": "Password",
  "auth.login.email.toolTip": "The password should be at least 8 characters long and include an upper case letter, a number and a symbol.",
  "auth.login.donHaveAnAccount": "Don’t have an account? {signUpLink}",
  "auth.login.signUpLinkText": "Create Account",
  "auth.login.fail.badCredentials":
    "An account with these details cannot be found. Please try again or {contactUsLink}.",
  "auth.login.fail.badCredentials2": "An account with these details cannot be found. The Sunbit app can only be accessed by existing Sunbit customers. Please try again or {contactUsLink}.",
  "auth.updateEmail.fail.msg": "Unexpected technical error. Please try again or {contactUsLink}.",
  "auth.login.fail.locked": "As a result of multiple unsuccessful login attempts, this feature has been suspended.",
  "auth.login.fail.lockedActions": "Please {resetAccountLink} to login or {contactUsLink}.",
  "auth.login.fail.recaptchaError": "Sorry, it seems that you are using a bot software which blocks you from logging in.",
  "auth.login.fail.resetPassword": "reset your password",
  "auth.login.invalidEmail": "Please enter a valid email address.",
  "auth.login.invalidPhoneOrEmail": "Please enter a valid phone number or email address",
  "auth.login.emptyPassword": "Password cannot be empty",
  "auth.label.signOut": "Sign out",

  "auth.title.notFound": "Account Not Found",
  "auth.message.notFound": "An account with these details cannot be found.",
  "auth.message.tryAgain": "Please {tryAgainLink} or {contactUsLink}.",
  "auth.message.tryAgainNotRegistered": "Please {signUp} or {contactUsLink}.",
  "auth.accountNotFound.Please": "Please",
  "auth.accountNotFound.tryAgain": "try again",
  "auth.accountNotFound.orContactUs": "or {contactUsLink}.",
  "auth.title.locked": "Account Locked",
  "auth.message.locked":
    "Your account has been locked as a result of too many unsuccessful attempts. Please {contactUsLink} to unlock your account. We apologize for this inconvenience.",
  "auth.title.alreadyExists": "Account Already Exists",
  "auth.message.alreadyExists":
    "We've found an account associated with the information you provided. You can {loginLink} or {resetLink} your password.",

  "auth.title.resetFailed": "Invalid Reset Link",
  "auth.message.resetFailed":
    "Reset password failed, probably because this link expired or has already been used.  You can {loginLink} or try to {resetLink} your password again.",

  "auth.createPassword": "Create Password",
  "auth.newPassword": "New password",
  "auth.repeatPassword": "Repeat Password",
  "auth.retypePassword": "Retype Password",

  "validations.required": "Required",
  "validations.passwordRules.length":
    "Password must be at least 8 characters long",
  "validations.passwordRules.lowercase":
    "Password must include at least 1 lowercase character",
  "validations.passwordRules.uppercase":
    "Password must include at least 1 uppercase character",
  "validations.passwordRules.digit": "Password must include at least 1 digit",
  "validations.passwordRules.special":
    "Password must include at least 1 special character (#?!@$%^&*-)",
  "validations.passwordRules.general":
    "The password should be at least 8 characters and include an uppercase letter, a number and a symbol.",
  "validations.verifyPassword": "Passwords do not match",

  "dashboard.title": "My Account",
  "dashboard.subtitle": "See an overview of your sunbit activity",

  "disclosures.NoticeOfCreditScore.title": "Notice Of Credit Score",
  "disclosures.PrivacyNotice.title": "Privacy Notice",
  "disclosures.SiteTermsOfUse.title": "Site Terms Of Use",

  "common.yes": "Yes",
  "common.no": "No",
  "common.ok": "ok",
  "common.continue": "continue",
  "common.next": "next",
  "common.update": "update",
  "common.cancel": "cancel",
  "common.confirm": "confirm",
  "common.done": "done",
  "common.select": "Select",
  "common.back": "back",
  "common.pay": "pay",
  "common.payNow": "Pay Now",
  "common.dueDate": "Due Date",
  "common.amount": "Amount",
  "common.agreeAndPay": "AGREE & PAY",
  "common.close": "close",
  "common.tryAgain": "Try again",
  "common.signUp": "sign up",
  "common.login": "Sign in",
  "common.reset": "Reset",
  "common.link.termsOfUse.text": "Terms Of Use",
  "common.link.contactUs.text": "contact us",
  "common.link.contactUs.text.capitalized": "Contact Us",
  "common.link.privacyPolicy.text": "Privacy Policy",
  "common.link.faq.text": "FAQ",
  "common.link.privacyAgreement.text": "Sunbit Privacy Policy",
  "common.link.californiaPrivacyChoices.text": "Privacy Choices",
  "common.link.glba.text": "GLBA Notice",
  "common.link.glbaTab.text": "TAB Bank GLBA Notice",
  "common.tabsNav.card": "Sunbit Card",
  "common.tabsNav.installments": "Installment Loans",
  "common.technicalError": "Unexpected technical error, please try again or contact us.",
  "common.recurringPaymentAuthorization.text":"Recurring Payment Authorization",

  "app.banner.btnLabel": "View",
  "app.banner.message": "Sunbit App",

  "card.label.heading": "Sunbit Card",
  "card.action.makeAPayment": "Make Payment",

  "card.autopay.error.TransactionDeclined": "Unfortunately, we are unable to validate your card. Please contact your card issuer for more information.",
  "card.autopay.error.WrongCardType": "This card type is not accepted. Please use a valid bank-issued debit card",
  "card.autopay.error.PaymentProfileError": "Technical error has occurred. Please try again later.",
  "card.settings.error.UpdateError": "Technical error has occurred. Please try again later.",
  "card.payment.error.bankrupt.account": "Payment processing for this account has been restricted. Please contact us at {phoneNumber} for more details.",
  "card.paymentMethod.current.mail.text":"Current Payment Method (Mail)",
  "card.paymentMethod.current.debitRcc.text":"Current Payment Method (ending in {last4Digits})",
  "card.paymentMethod.debit.text":"New Debit Card",
  // not deleting it because there is a chance we will want to add RCC back in the future. for more info see this Jira ticket SBT-21058
  // "card.paymentMethod.rcc.text":"New Remotely Created Check",
  "card.paymentMethod.rcc.tooltipText":"Remotely created checks generally look like checks you would write, " +
    "but they do not have your signature. They generally post to your bank account in the same way as regular checks you write.",

  "card.statement.viewStatements":"View Statements",
  "card.statement.statement":"Statement",
  "card.statement.downloadStatement": "Download Statement",

  "purchases.label.heading": "Account Activity",
  "purchases.nav.label.allPurchases": "All Purchases",
  "purchases.nav.label.activePurchases": "Active Purchases",
  "purchases.empty.all.text":
    "No purchases to display. It’s time to head to the store and ask about Sunbit!",
  "purchases.empty.active.text":
    "No active purchases to display. It’s time to head to the store and ask about Sunbit!",
  "purchase.info.label.purchaseExternalId": "Agreement No.:",
  "purchase.info.label.retailerName": "Retailer:",
  "purchase.info.label.purchaseDate": "Purchase Date:",
  "purchase.info.label.paymentPlanStatus": "Status:",
  "purchase.info.label.purchasePrice": "Purchase price (inc. tax)",
  "purchase.info.label.payoffAmount": "Total Outstanding Balance",
  "purchase.info.label.payoffAmountInfo":
    "This is the total outstanding amount as of today. This balance may not include mail, remotely created check, or returned payments.",
  "purchase.info.label.downPayment": "Down Payment",
  "purchase.info.label.paidOn": "Paid On",
  "purchase.action.label.payNow": "Make a Payment",
  "purchase.action.label.viewPayments": "View payments",
  "purchase.paymentsInfo.amountDescription.nextPayment": "Next payment",
  "purchase.paymentsInfo.amountDescription.late": "Total amount past due",
  "purchase.notPayable.notice": "Unfortunately, we cannot process your payment using this automated service. Please call Customer Support at {phoneNumber} to complete this action. We apologize for the inconvenience.",
  "purchase.inactive.reason.canceled": "Canceled",
  "purchase.inactive.reason.default": "Default",
  "purchase.inactive.reason.paid": "Paid",
  "purchase.details.promotional.text":
    "No finance charges if paid in full by {date}. {seeImportantDetails}",
  "purchase.details.promotional.importantDetails": "See Important Details.",
  "purchase.details.promotional.details":
    " If you pay the amount financed in full by {date}, 11:59 PM PT, then you will not pay any finance charges. If you do not pay the amount financed in full by that time, then you will be responsible for paying all finance charges that have accrued and will accrue from the date of your agreement.",

  "purchase.info.status.onSchedule": "On Schedule",
  "purchase.info.status.late": "Late",
  "purchase.info.status.paid": "Paid",
  "purchase.info.status.dispute": "Dispute",
  "purchase.info.status.paused": "Paused",
  "purchase.info.status.canceled": "Canceled",
  "purchase.info.status.default": "Default",
  "purchase.info.status.unknown": "Unknown",
  "purchase.banner.limitedOffer": "Limited time offer",
  "purchase.banner.getThe": "Get the Sunbit Card with no annual fee and no late fees. Apply today.",
  "purchase.banner.applyNow": "Apply now",
  "purchase.banner.continue": "Continue",
  "purchase.banner.issuedBy": "The Sunbit Card is issued by TAB Bank, pursuant to a license from Visa U.S.A. Inc.",
  "purchase.banner.unfinishedApplication": "You have an unfinished Sunbit Card application",

  "purchase.document.error":
    "Unfortunately, this document is not accessible on this website at the moment. Please {contactUsLink} in order to obtain a copy. We apologize for the inconvenience.",
  "purchase.document.correction.error":
    "This notice has been sent to your email in accordance with your consent to electronic communication or in any other fashion per your instructions. If you have any questions or would like to request an additional copy of this notice, please {contactUsLink}.",
  "purchase.document.confirm":
    "The document will be displayed in a new tab. Please click confirm to continue.",

  "purchase.schedule.info.text":
    'Your financing agreement contains a payment schedule. All scheduled payments are denoted by numbers and reflect your payment schedule. "Manual" payments are those that you requested to pay in addition or instead of scheduled payments using this website or by contacting us directly.',

  "payment.method.debit": "Debit Card",
  "payment.method.remoteCheck": "Remotely created check",

  "payNow.info.purchase.id": "Purchase",
  "payNow.info.purchase.date": "Purchase Date:",
  "payNow.info.purchase.retailer": "Retailer:",

  "payNow.amount.title": "What do you want to pay?",
  "payNow.amount.option.pastDue": "Pay total past due amount ({pastDueAmount})",
  "payNow.amount.option.partial": "Other amount",
  "payNow.amount.option.next": "Pay next {nextPayments} payments",
  "payNow.amount.option.entire":
    "Pay entire outstanding balance ({leftAmountToPay})",
  "payNow.amount.entire.label": "Remaining Total Price",
  "payNow.amount.entire.promotion":
    "This amount does not include any finance charges due to the {promotionalPeriod}",
  "payNow.amount.entire.promotionalPeriod": "promotional period.",
  "payNow.amount.entire.promotional.dialog":
    "This amount does not include any finance charges due to the promotional period. If you pay {amount} by {date}, 11:59 PM PT, then you will not pay any finance charges. If you do not pay this amount by that time, then you will be responsible for paying all finance charges that have accrued and will accrue from the date of your agreement.",
  "payNow.amount.partial.hint": "Select payment amount", //should be "Type the payment amount"
  "payNow.amount.partial.appyOption.title": "After my late balance is paid, apply payment to:", //should be "Type the payment amount"
  "payNow.amount.partial.nextPaymentDue":
    "Your next payment in the amount of {amount} is due on {dueDate}", //should be "Type the payment amount"
  "payNow.amount.partial.appyOption.next": "Next payment(s)", //should be "Type the payment amount"
  "payNow.amount.partial.appyOption.last": "Last payment(s)", //should be "Type the payment amount"

  // 'payNow.amount.option.partial.info' :'This payment will not necessarily impact your next scheduled payment but could count as an extra payment that may reduce your principal balance and finance charge. This will not impact any automated debits that you have set up, and you will still owe your next scheduled payment on its due date.',
  "payNow.amount.option.partial.info.nextPayments":
    "This payment(s) will eliminate or reduce your next scheduled payment(s) and reduce or eliminate any automatic debit you set up for such payment(s). Any automatic payments you authorized will continue to be charged after this payment is applied.",
  "payNow.amount.option.partial.info.lastPayments":
    "This payment will not necessarily impact your next scheduled payment but could count as an extra payment that may reduce your principal balance and finance charge. This will not impact any automated debits that you have set up, and you will still owe your next scheduled payment on its due date.",
  "payNow.amount.option.next.info":
    "This payment(s) will eliminate or reduce your next scheduled payment(s) and reduce or eliminate any automatic debit you set up for such payment(s). Any automatic payments you authorized will continue to be charged after this payment is applied.",
  "payNow.amount.option.entire.info":
    "This payment will pay off the outstanding balance of your loan.",
  "payNowPastDue.amount.option.totalPastDue": "This payment will cover the total past due amount of your loan.",
  "payNowPastDue.amount.option.partial.info.noExcessAmount": "This payment will be applied first to any late payments. Any excess payment amount will then be applied to your last or next scheduled payments, according to your selection.",
  "payNowPastDue.amount.option.partial.info.nextPayments": "This payment will be applied first to any late payments. The exceeds payment(s) will eliminate or reduce your next scheduled payment(s) and reduce or eliminate any automatic debit you set up for such payment(s). Any automatic payments you authorized will continue to be charged after this payment is applied.",
  "payNowPastDue.amount.option.partial.info.lastPayments": "This payment will be applied first to any late payments. The excess payment will not necessarily impact your next scheduled payment but could count as an extra payment that may reduce your principal balance and finance charge. This will not impact any automated debits that you have set up, and you will still owe your next scheduled payment on its due date.",

  "payNow.paymentMethod.Title": "Payment Method",
  "payNow.paymentMethod.current": "Current Payment Method: {paymentMethod}",
  "payNow.paymentMethod.other": "Other Debit Card",
  "payNow.paymentMethod.onlyDebitInfo": "Online payments can only be made using a debit card. Please add a debit card, or {contactUsLink} to use a different payment method.",
  "payNow.schedule.title": "Select Payment Date",
  "payNow.schedule.option.today": "Today",
  "payNow.schedule.option.future": "Future date",
  "payNow.schedule.info":
    "This would be your updated payment plan once you submit your payment",
  "payNow.schedule.zeroApr.text": "Doesn't include finance charges",

  "payNow.payments.payment.paid": "Paid",
  "payNow.payments.payment.manual": "Manual",
  "payNow.payments.payment.updated": "Amount updated",

  "payNow.method.title": "Select your desired method of payment",
  "payNow.method.option.debitCard": "Debit Card",
  "payNow.method.option.remoteCheck": "Remotely created check",

  "payNow.consent.message":
    'By clicking "AGREE & PAY", you authorize Sunbit (including our successors, agents and assigns) to charge your payment card ending in {cardNumber} (the "Card") for the amount you specify above today, and apply the payment to Purchase No. {externalId}. You agree that we will apply your payment {amountOptionText}. If we make an error in seeking payment, you authorize us to correct the error, on or after the date it occurs, by initiating a charge or credit to the Card in the amount of the error. You certify that you are an authorized user of the Card.',
  "makeAPaymentPurchaseReviewDisclaimer": `By clicking "Agree & Pay", you authorize Sunbit (including our successors, assigns, agents, and service providers) to charge the Debit Card in the Payment Amount and for the Agreement specified above today in accordance with the terms of the Agreement. You agree that we will apply your payment per your previous selection. You also certify that you are an authorized user of the Debit Card.`,
  "makeAPaymentPurchaseReviewDisclaimer.AutoPay": `By clicking "Agree & Pay", you authorize Sunbit (including our successors, assigns, agents, and service providers) to charge the Debit Card in the Payment Amount and for the Agreement specified above today, in accordance with the terms of the Agreement. You agree that we will apply your payment per your previous selection. By clicking "Agree & Pay", you also authorize us to charge the Debit Card for your automatic payments in accordance with the terms of the Payment Authorization of the Agreement. You also certify that you are an authorized user of the Debit Card.`,
  "makeAPaymentPurchaseReviewDisclaimer.Late":`By clicking "Agree & Pay", you authorize Sunbit (including our successors, assigns, agents, and service providers) to charge the Debit Card in the Payment Amount and for the Agreement specified above today in accordance with the terms of the Agreement. You agree that after any late amount is satisfied, we will apply your payment per your previous selection. You also certify that you are an authorized user of the Card.`,
  "makeAPaymentPurchaseReviewDisclaimer.LateAutoPay": `By clicking "Agree & Pay", you authorize Sunbit (including our successors, assigns, agents, and service providers) to charge the Debit Card in the amount and for the Agreement specified above today in accordance with the terms of the Agreement. You agree that after any late amount is satisfied, we will apply your payment per your previous selection. By clicking "Agree & Pay", you also authorize us to charge the Debit Card for your automatic payments in accordance with the terms of the Payment Authorization of the Agreement. You also certify that you are an authorized user of the Debit Card.`,
  "payNow.consent.option.partial": "as an extra payment",
  "payNow.consent.option.totalPastDue": "Pay total past due amount",
  "payNow.consent.option.next": "to your next scheduled payment",
  "payNow.consent.option.entire": "to pay off your balance",

  "payNow.confirm.title": "Confirm your payment",
  "payNow.confirm.instructions": "Please confirm your purchase for:",
  "payNow.confirm.amount": "Amount:",
  "payNow.confirm.date": "Date:",
  "payNow.confirm.method": "Payment method:",
  "payNow.confirm.paid": "Paid",
  "payNow.confirm.successMessage": "Thank you for your payment",
  "payNow.confirm.successTitle": "Payment confirmed",

  "payNow.feature.notAvailable": "Not available at this time",
  "payNow.errors.amount.exceed":
    "The amount cannot exceed the remaining balance of {maximum}",
  "payNow.errors.amount.below": "Payment amount cannot be lower than {minimum}",
  "payLate.authorization.language":
    'By clicking "AGREE & PAY," you authorize Sunbit (including our successors, agents and assigns) to charge your payment card ending in {cardNumber} (the "Card") for the amount you specify above today, and apply the payment to Retail Installment Contract {externalId}. If we make an error in seeking payment, you authorize us to correct the error, on or after the date it occurs, by initiating a charge or credit to the Card in the amount of the error. You certify that you are an authorized user of the Card.',

  "updateDebitCard.currentDebitCard":
    "Current Debit Card on file - ending in {cardLast4Digits}",
  "updateDebitCard.form.instructions": "Enter New Debit Card Details Below",
  "updateDebitCard.form.cardNumber": "Card Number",
  "updateDebitCard.form.expirationDate": "Expiration Date",
  "updateDebitCard.form.cvv": "CVV",
  "updateDebitCard.applyToAllPurchases.text":
    "Apply this card to {allPurchases}",
  "updateDebitCard.applyToAllPurchases.linkTitle": "all purchases",
  "updateDebitCard.authorization.singlePurchase":
    'You authorize us to charge the debit card ending in {cardLast4Digits} under the terms set forth in the Payment Authorization in your Financing Agreement (Loan Agreement or Retail Installment Contract), No. {externalId}, in lieu of charging any prior debit card you may have provided or in lieu of creating remotely created checks drawn on a deposit account of yours. By clicking "CONFIRM," you also certify that you are an authorized user of the above debit card.',
  "updateDebitCard.authorization.singlePurchase.success":
    "Your debit card has been updated successfully. We've sent an email to {email} confirming this change.",
  "updateDebitCard.authorization.singlePurchase.fail":
    "Unfortunately, we were unable to validate the debit card details or your card is not supported. Please try again or {contactUs}.",
  "updateDebitCard.authorization.title": "Update Debit Card",
  "updateDebitCard.changeNotSupported.text":
    "Unfortunately, changing your debit card for this purchase is not supported. Please call Customer Support at {phoneNumber} to complete this action. We apologize for the inconvenience.",
  "updateDebitCard.hasLatePayments.title": "Payments are past due",
  "updateDebitCard.hasLatePayments.text":
    "One or more of your payments are past due. Would you like to make a payment now?",
  "updateDebitCard.form.error.expired": "Card Expired",

  "forgotPassword.fromLogin.text":
    "Forgot Password? {clickHere} to reset your password",
  "forgotPassword.fromLogin.clickHere": "Click Here",
  "forgotPassword.title": "Forgot Your Password",
  "forgotPassword.title.reset": "Reset your password",
  "forgotPassword.remember": "Return to {signIn}",
  "forgotPassword.success.resetMessage": `An email with further instructions was sent to your email address.`,
  "common.success.didntReceiveEmail": `If you don't receive an email or you need further assistance please call {phoneNumber}.`,
  "forgotPassword.success.message": "Your password has been reset.",
  "forgotPassword.success.message2":
    "Please click on the password reset link which was sent to your email address.",
  "forgotPassword.button.confirm": "Get Reset Link",
  "forgotPassword.button.continue": "Continue",
  "passwordUpdated.title.message": "Your password has been updated.",
  "passwordUpdated.createPassword.message": "Please create a password for your account.",
  "passwordUpdated.error.fullSSNRequired": "Due to multiple unsuccessful attempts, please enter your full SSN/ITIN.",

  "resetPassword.title": "Reset Your Password",
  "createNewPassword.title": "Create a new password",
  "resetPassword.instructions":
    "Please type your new password to complete the process",
  "createNewPassword.instructions":
    "Your password should be at least 8 characters and include an uppercase letter, a number and a symbol.",
  "resetPassword.button.confirm": "Reset Password",
  "createNewPassword.button.save": "Save",

  "registration.title": "Create Account",
  "registration.titleSignUp": "Sign up",
  "registration.instructions":
    "Please enter the details which were provided during your application",
  "forgotPassword.instructions":
    "Please enter your details to reset your password.",
  "registration.pleaseEnterDetails":
    "Please enter your details to access your Sunbit account.",
  "registration.field.label.licenseNumber": "Your ID/Driver License Number",
  "registration.field.label.licenseNumberErrorMissing":
    "The ID/Driver license number cannot be empty.",
  "registration.field.label.dateOfBirth": "Your Date of Birth (MM/DD/YYYY)",
  "registration.field.label.dateOfBirthError":
    "Please enter your date of birth in MM/DD/YYYY format.",
  "registration.field.label.dateOfBirthErrorMissing":
    "Please enter your date of birth.",
  "registration.field.label.phoneNumber": "Your Phone Number",
  "registration.field.label.phoneNumberError":
    "Please enter a valid 10-digit phone number.",
  "registration.field.label.phoneNumberErrorMissing":
    "Please enter your phone number.",
  "registration.field.label.email": "Your email",
  "registration.field.label.phoneOrEmail": "Phone number or email",
  "registration.field.label.emailError": "Please enter a valid email.",
  "registration.field.label.emailOrPhoneError": "Please enter a valid phone number or email address",
  "registration.field.label.emailErrorMissing": "Please enter your email.",
  "registration.field.label.emailOrPhoneErrorMissing": "Please enter your email or phone number.",
  "registration.field.label.ssn": "Your SSN (9 digits)",
  "registration.field.label.ssnError": "Please enter your SSN (9 digits)",
  "registration.field.label.ssnErrorMissing": "Please enter your SSN",
  "registration.field.label.ssn4Digits": "Last 4 digits of your SSN/ITIN",
  "registration.field.label.ssn4DigitsError":
    "Please enter the last 4 digits of your SSN",
  "registration.field.label.noAccount": "An account with these details cannot be found. The Sunbit app can only be accessed by existing Sunbit customers." ,
  "registration.field.label.noAccountTryAgain": "Please try again or {contactUsLink}.",
  "registration.field.label.ssn4DigitsErrorMissing":
    "Please enter the last 4 digits of your SSN/ITIN",
  "registration.button.signUp": "Agree & Sign Up",
  "otpType.button.approveOtpType": "Agree & Continue",
  "otpType.termsAndConditions.text": "Terms & Conditions",
  "otpType.callMe.legalText": "By tapping “Agree & Continue”, you agree to receive from Sunbit one autodialed, pre-recorded, or artificial call with a verification code at the number above. Phone plan charges may apply. {termsAndConditions}. {privacyPolicy}.",
  "otpType.textMe.legalText": "By tapping “Agree & Continue”, you agree to receive from Sunbit one text message with a verification code at the number above. Message and data rates may apply. {termsAndConditions}. {privacyPolicy}.",
  "registration.button.continue": "Agree & Continue",
  "registration.signUp.consent.text":
    'By clicking "{buttonConfirmText}" below you consent to our {privacyPolicy} and {termsOfUse}',
  "registration.signUp.privacyPolicy.text": "Privacy Policy",
  "registration.signUp.termsOfUse.text": "Terms of Use",
  "registration.already": "Already have an account? {signIn}",
  "registration.success.title": "Thanks",
  "registration.success.message":
    "A personalized Sunbit activation link has been sent to the email address on file.",
  "registration.success.message2":
    "Please click on this link to create your account.",
  "registration.notCustomerMessage":
    "Sunbit access is only available for consumers who made purchases at Sunbit Program participating retailers",
  "registration.error.fullSSNRequired": "Due to multiple unsuccessful attempts, please enter your full SSN/ITIN.",

  "registration/forgotPassword.TooManyAttempts.exceeded": "Too many failed attempts. Your account is temporarily locked.",
  "registration/forgotPassword.TooManyAttempts.tryAgain": "Please try again later. If the problem persists, please contact our customer support at 855-788-6248.",
  "registration/forgotPassword.TooManyAttempts.retryIn": "Retry",

  "phoneNumberUpdate.title": "Update your phone number",
  "phoneNumberUpdate.subTitle": "Please provide the following details in order to update your phone number. If you need help, you can contact our customer support at 855-788-6248.",
  "phoneNumberUpdate.ssnInput" : "Last 4 digits of your SSN/ITIN",
  "phoneNumberUpdate.paymentMethodDigitsInput" : "Last 4 digits of your payment method",
  "phoneNumberUpdate.newPhoneNUmberInput" : "New phone number",
  "phoneNumberUpdate.field.label.phoneErrorMissing": "Please enter your phone number.",
  "phoneNumberUpdate.field.label.phoneError": "Please enter a valid phone number.",
  "phoneNumberUpdate.field.label.paymentMethod4DigitsError":
    "Please enter the last 4 digits of your payment method",
  "phoneNumberUpdate.button.continue":
    "Continue",
  "atpUpdate.subtitle" : "Keep your income and housing information up to date to help Sunbit consider you for credit line increases.",
  "atpUpdate.lasUpdate" : "Your income was updated on {lastAtpUpdateDate}.",
  "atpUpdate.expenses.HousingType" : "Housing Status",
  "atpUpdate.expenses.helperText" : "Sum of your monthly rental or mortgage payments, plus any other monthly expenses" +
    " associated with your home such as insurance, taxes or utilities.",
  "atpUpdate.expenses.label" : "Monthly Housing Expenses",
  "atpUpdate.income.infoLink" : "What is Total Net Monthly Income?",
  "atpUpdate.income.modal.title" : "What is Total Net Monthly Income?",
  "atpUpdate.income.modal.subtitle" : "This is the amount you take home after taxes or the amount you can reasonably expect to have access to each month.",
  "atpUpdate.income.modal.content.line1" : "Income includes current or reasonably expected salary, wages, bonus pay, tips, and commissions.",
  "atpUpdate.income.modal.content.line2" : "Employment may be full-time, part-time, seasonal, irregular, military, or self-employment.",
  "atpUpdate.income.modal.content.line3" : "Other sources of income include interest or dividends, retirement benefits, public assistance," +
    " alimony, child support, separate maintenance payments, and income that is being deposited regularly" +
    " into an account on which you are an account holder.",
  "atpUpdate.income.modal.content.line4":"If you are under age 21, include only your own personal income.",
  "atpUpdate.income.label"  : "Total Net Monthly Income",
  "atpUpdate.success.dialog.title" : "You’ve updated your income.",
  "atpUpdate.success.dialog.content" : "Thank you, we’ll let you know if you are eligible for additional offers.",
  "atpUpdate.success.dialog.backToSettingBtn" : "Back to settings",
  "atpUpdate.success.dialog.backToAccountsBtn" : "Go to card homepage",
  "atpUpdate.salaryOutOfRange.dialog.title" : "Please ensure that you entered your FULL MONTHLY net income (including all sources of income).",
  "atpUpdate.salaryOutOfRange.dialog.content" : "This is the amount you take home after taxes or the amount you can reasonably expect to have access to each month. Income includes current or reasonably expected wages, salary, retirement " +
    "income, public assistance, alimony, child support, interest or dividends, and separate maintenance income. If you are under 21, include only your own income.",
  "atpUpdate.salaryOutOfRange.dialog.updateAction" : "Edit income",
  "atpUpdate.salaryOutOfRange.dialog.continueAction" : "Continue",
  "atpUpdate.updateBanner.mainText" : "{firstName}, you may be eligible for a credit limit increase. Update your income to check!",
  "atpUpdate.updateBanner.actionBtn" : "Update ATP",
  "otp.form.plsEnter": "Please enter the code sent to",
  "otp.form.weWillSend": "We will send a verification code to",
  "otp.form.chooseOption": "Choose an option below to continue:",
  "otp.form.invalidCode": "Incorrect code, please try again.",
  "otp.form.timeForCode": "It may take up to 60 seconds for the verification code to arrive.",
  "otp.form.didntGetCode": "Didn't receive a verification code?",
  "otp.form.sendAgain": "Send again",
  "otp.form.or": "or",
  "otp.form.callMe": "Call me",
  "otp.TooManyAttempts.exceeded": "You've exceeded the number of allowed attempts.",
  "otp.TooManyAttempts.tryAgain": "Please try again. If the problem persists, please contact our customer support at 855-788-6248.",
  "otp.TooManyAttempts.retryIn": "Retry in",
};



// WEBPACK FOOTER //
// ./src/locale/en.js